import { Title } from "react-head";
import { LinkPageButton } from "./components/LinkPageButton";
import { LinkPageContactCards } from "./components/LinkPageContactCards";
import { LinkPageHeader } from "./components/LinkPageHeader";
import { LinkPageMap } from "./components/LinkPageMap";
import { usePublicStudioLinkPage } from "./hooks/usePublicStudioLinkPage";
import styles from "./PublicStudioLinkPage.module.scss";
import { StudioNotFound } from "../../common/components/errorPages/StudioNotFound";

/**
 * The studio's public, shareable link page (multy.me / Linktree-style), served from the
 * studio's own domain at /l/:slug. Rendered standalone — no app chrome, no studio picker,
 * no auth — because whoever opens it is usually not a logged-in user of the studio.
 */
export const PublicStudioLinkPage = () => {
  const {
    isLoading,
    isError,
    studioName,
    logoUrl,
    address,
    mapsUrl,
    phones,
    hasContactCards,
    items,
    hasItems,
    buttonColor,
  } = usePublicStudioLinkPage();

  if (isLoading) {
    return <div className={styles.root} />;
  }

  if (isError) {
    return <StudioNotFound />;
  }

  return (
    <div
      className={styles.root}
      style={{ "--link-button-color": buttonColor } as React.CSSProperties}
    >
      <Title>{studioName}</Title>

      {/* Two slow-drifting blurs in the studio's colors, behind the glass. */}
      <div className={styles.root_ambience} aria-hidden="true">
        <span className={styles.root_ambience_orb} />
        <span className={styles.root_ambience_orb} />
      </div>

      <div className={styles.root_content}>
        <div className={styles.root_panel}>
          <LinkPageHeader studioName={studioName} logoUrl={logoUrl} />

          {hasContactCards && (
            <LinkPageContactCards
              address={address}
              mapsUrl={mapsUrl}
              phones={phones}
            />
          )}

          <LinkPageMap address={address} />

          {hasItems ? (
            <div className={styles.root_links}>
              {items.map((item, index) => (
                <LinkPageButton key={`${item.url}-${index}`} item={item} />
              ))}
            </div>
          ) : (
            <p className={styles.root_message}>Все още няма добавени линкове.</p>
          )}
        </div>

        <a
          className={styles.root_footer}
          href="https://yourplanny.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={styles.root_footer_text}>Powered by</span>
          <img
            className={styles.root_footer_logo}
            src="/planny-wordmark-color-p.png"
            alt="Planny"
          />
        </a>
      </div>
    </div>
  );
};
